import camelize from 'camelcase-keys-deep';

export default class DocumentType {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
